import { useLayoutEffect } from 'react';
import { toast } from 'react-toastify';
import routes from '../../../../../../../Routes/routes';
import { errorMsg } from '../../../../../../../Apis/functions';
import { CreateAttendanceShift } from '../../../../../../../reduxToolkit/AttendanceShift/AttendanceShiftApi';
import CommonShiftAccessApp from './CommonShiftAccessApp';
import { STEPS_CREATE_SHIFT_ACCESS } from '../Model/Models';

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Create-only hook. Builds the create stepper labels and submits the single
 * shift body (toRegister) once. Mirrors Devices CreateDevicesApp.
 */
export const AddShiftAccessApp = () => {

    const {
        t,
        DEV,navigate,
        permission,
        emptyFields,
        disabled, dispatch,
        item,validate,
        handleChange,state,

        devices, setDevices,
        selectDeleteDevices, setSelectDeleteDevices,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,

        user, setUser,
        selectDeleteUser, setSelectDeleteUser,
        searchElement,
        setSearchElement,
        steps,setSteps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleOnBack,
        modified, setModified
    } = CommonShiftAccessApp();

    useLayoutEffect(() => {
        const stepArray = Object.values(STEPS_CREATE_SHIFT_ACCESS)
            .filter(step => step?.TRANS && typeof step.INDEX === "number")
            .sort((a, b) => a.INDEX - b.INDEX)
            .map(step => t(step.TRANS));
        setSteps(stepArray);
    }, [t]);

    /**
     * Validates, builds the shift body and creates it; on success notifies and
     * navigates back to the list.
     */
    const handleAddEdit = () => {
        if (!validate()) return;
        const body = item.toRegister(devices, departments, user);
        dispatch(CreateAttendanceShift(body)).then(({ payload: { data: { success, data, code } } }) => {
            if (success && data?.id) {
                toast.success(t('has_been_created_successfully'));
                navigate(routes.attendance.list, { state });
            } else errorMsg(code);
        });
    }

    return {
        t,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        devices, setDevices,
        selectDeleteDevices, setSelectDeleteDevices,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,
        modified, setModified,
        user, setUser,
        selectDeleteUser, setSelectDeleteUser,
        searchElement,
        setSearchElement,
        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleAddEdit,
        handleOnBack
    }
}
